<template>
    <main class="page alternative">

        <div v-if="service !== false" class="alternative-single">

            <section class="auto start background-dark">
                <div class="inner">
                    <div class="title">
                        <a href="https://app.sleekplan.com/sign-up/" class="badge" v-if="service.migration === true">
                            <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><title>Rocket</title><path d="M461.81 53.81a4.4 4.4 0 00-3.3-3.39c-54.38-13.3-180 34.09-248.13 102.17a294.9 294.9 0 00-33.09 39.08c-21-1.9-42-.3-59.88 7.5-50.49 22.2-65.18 80.18-69.28 105.07a9 9 0 009.8 10.4l81.07-8.9a180.29 180.29 0 001.1 18.3 18.15 18.15 0 005.3 11.09l31.39 31.39a18.15 18.15 0 0011.1 5.3 179.91 179.91 0 0018.19 1.1l-8.89 81a9 9 0 0010.39 9.79c24.9-4 83-18.69 105.07-69.17 7.8-17.9 9.4-38.79 7.6-59.69a293.91 293.91 0 0039.19-33.09c68.38-68 115.47-190.86 102.37-247.95zM298.66 213.67a42.7 42.7 0 1160.38 0 42.65 42.65 0 01-60.38 0z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32"/><path d="M109.64 352a45.06 45.06 0 00-26.35 12.84C65.67 382.52 64 448 64 448s65.52-1.67 83.15-19.31A44.73 44.73 0 00160 402.32" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32"/></svg>
                            <span>Automated 1 Click Migration</span>
                        </a>
                        <h1 v-if="service.title && service.title.general !== false"> {{service.title.general}} </h1>
                        <h1 v-else> Alternatives to {{name}} </h1>
                        <span class="h2"> Looking for the best alternative to {{name}}? See why the others choose Sleekplan over {{name}}. </span>
                        <div>
                            <br><br>
                            <a href="https://app.sleekplan.com/sign-up/" class="btn ularge uppercase" rel="nofollow">Sign up for free</a>
                        </div>
                    </div>
                </div>
                <div class="background">
                    <div class="rect top-left"></div>
                    <div class="rect top-right"></div>
                    <div class="featured mobile-hidden">
                        <div class="featured-inner">
                            <div class="widget-wrapper animation delay">
                                <div class="widget">
                                    <picture>
                                        <source srcset="/assets/pages/alternative/alternative-widget-1x.webp 1x, /assets/pages/alternative/alternative-widget-2x.webp 2x" type="image/webp">
                                        <source srcset="/assets/pages/alternative/alternative-widget-1x.jpg 1x, /assets/pages/alternative/alternative-widget-2x.jpg 2x" type="image/jpeg"> 
                                        <img src="/assets/pages/alternative/alternative-widget-1x.jpg" :alt="'Feedback widget as alternative to ' + name" width="350" height="643">
                                    </picture>
                                </div>
                            </div>
                            <div class="desktop animation" :class="widget_mode">
                                <div class="desktop-bar">
                                    <span></span><span></span><span></span>
                                </div>
                                <div class="desktop-url">
                                    <div>feedback.company.io</div>
                                </div>
                                <div class="desktop-video">
                                    <picture>
                                        <source srcset="/assets/pages/alternative/alternative-dashboard-1x.webp 1x, /assets/pages/alternative/alternative-dashboard-2x.webp 2x" type="image/webp">
                                        <source srcset="/assets/pages/alternative/alternative-dashboard-1x.jpg 1x, /assets/pages/alternative/alternative-dashboard-2x.jpg 2x" type="image/jpeg"> 
                                        <img src="/assets/pages/alternative/alternative-dashboard-1x.jpg" :alt="'Feedback website as alternative to ' + name" width="1000" height="570">
                                    </picture>
                                </div>
                            </div>
                            <div class="shadow-outer">
                                <div class="shadow"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="round white">
            <div class="inner">
                
                <div class="content-large">

                    <h2>{{name}} Alternatives</h2>

                    <span>
                        <span v-html="service.text"></span>
                        <br />
                        <p v-html="service.desc"></p>
                        <br />
                        <h3>Table of contents:</h3>
                        <ul>
                            <li>
                                <a href="#sleekplan"><b>Sleekplan: User Feedback Tool</b></a>
                            </li>
                            <li v-for="(alternatives, index) in Object.values(alternative_list).slice(0, 5)" :key="index">
                                <a v-if="index < 4" :href="'#alternative-' + alternatives.name.toLowerCase()">{{index + 1}}. {{alternatives.name}} as {{name}} alternative</a>
                                <a v-else :href="'#alternative-' + alternatives.name.toLowerCase()">More {{name}} alternatives..</a>
                            </li>
                        </ul>
                    </span>

                </div>

            </div>
            </section>     

            <section class="light sleekplan">
                <div class="inner">
                    
                    <div class="content-large center">
                        <a name="sleekplan"></a>
                        <h2><span class="sub">Best-in-class {{name}} Alternative:</span> Sleekplan!</h2>
                        <span>Sleekplan is an alternative customer feedback management tool to {{name}} that helps you to cover the whole feedback loop - starting with the collection of feedback, through the prioritization and ongoing development of features, to the notification of your customers. With Sleekplan you get a fully integrated feedback solution made specifically for the needs of SaaS companies.</span>
                    </div>

                    <div class="compare-table mobile-hidden">
                        <div class="compare-row">
                            <div></div>
                            <div>
                                <img src="@/assets/media/logo/logo.svg" :alt="'Sleekplan as alternative to' + name">
                            </div>
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><title>{{name}} alternative</title><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M304 48l112 112-112 112M398.87 160H96M208 464L96 352l112-112M114 352h302"/></svg>
                            </div>
                        </div>
                        <div class="compare-row title">
                            <div>Sleekplan vs. {{name}}</div>
                            <div>
                                <div>Sleekplan</div>
                            </div>
                            <div>
                                <div>{{name}}</div>
                            </div>
                        </div>
                        <div class="compare-row" v-for="(feature, key) in service.features" v-bind:key="key">
                            <div>{{feature.text}}</div>
                            <div>
                                <svg v-if="feature.sleekplan == true" xmlns="http://www.w3.org/2000/svg" class="y" viewBox="0 0 512 512"><title>Feature included at Sleekplan</title><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M416 128L192 384l-96-96"/></svg>
                                <svg v-else xmlns="http://www.w3.org/2000/svg" class="n" viewBox="0 0 512 512"><title>Feature not included at Sleekplan</title><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M368 368L144 144M368 144L144 368"/></svg>
                            </div>
                            <div>
                                <svg v-if="feature.other == true" xmlns="http://www.w3.org/2000/svg" class="y" viewBox="0 0 512 512"><title>Feature included at {{name}}</title><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M416 128L192 384l-96-96"/></svg>
                                <svg v-else xmlns="http://www.w3.org/2000/svg" class="n" viewBox="0 0 512 512"><title>Feature not included at {{name}}</title><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M368 368L144 144M368 144L144 368"/></svg>
                            </div>
                        </div>
                        <div class="compare-row">
                            <div>Pricing</div>
                            <div>
                                <div>from <b>$0/month</b></div>
                            </div>
                            <div>
                                <div>from <b>{{service.meta.price}}</b></div>
                            </div>
                        </div>
                        <div class="compare-row">
                            <div>Ease of use</div>
                            <div>
                                <div>easy</div>
                            </div>
                            <div>
                                <div>{{service.meta.easy}}</div>
                            </div>
                        </div>
                        <div class="compare-row">
                            <div>Target customer</div>
                            <div>
                                <div>all size companies</div>
                            </div>
                            <div>
                                <div>{{service.meta.audience}}</div>
                            </div>
                        </div>
                        <div class="compare-row">
                            <div>Billing is based on</div>
                            <div>
                                <div>set of features</div>
                            </div>
                            <div>
                                <div>{{service.meta.according}}</div>
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <section class="color features">
                <div class="inner large">

                    <div class="feature-list">

                        <div class="row">
                            <div class="col-xs-12 col-sm-4">
                                <div class="content-large mobile-center">
                                    <a name="sleekplan"></a>
                                    <h2><span class="sub">That's just the</span> tip of the iceberg</h2>
                                    <span>Designed for product managers, Sleekplan is an all-in-one user feedback tool and customer satisfaction platform. We don't want to compare each and every feature with <b>{{name}}</b>, see why:</span>
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-8">
                                <div class="feature-item">
                                    <div>
                                        <div>
                                            <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><title>Checkmark</title><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M416 128L192 384l-96-96"/></svg>
                                        </div>
                                        <div class="item-content">
                                            <b>In-app widget, standalone website or iframe</b>
                                            <span>Just one line of code and Sleekplan can easily be integrated straight into your existing web application.</span>  
                                        </div>
                                    </div>
                                </div>
                                <div class="feature-item">
                                    <div>
                                        <div>
                                            <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><title>Checkmark</title><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M416 128L192 384l-96-96"/></svg>
                                        </div>
                                        <div class="item-content">
                                            <b>Prioritize customer feedback</b>
                                            <span>Do not simply rely on up- and downvotes. Sleekplan prioritizes your feedback based on better factors.</span>  
                                        </div>
                                    </div>
                                </div>
                                <div class="feature-item">
                                    <div>
                                        <div>
                                            <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><title>Checkmark</title><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M416 128L192 384l-96-96"/></svg>
                                        </div>
                                        <div class="item-content">
                                            <b>Keep a changelog</b>
                                            <span>Keep your customers in the loop with new features. Notify customers about changes and record the ongoing progress in a changelog.</span>  
                                        </div>
                                    </div>
                                </div>
                                <div class="feature-item">
                                    <div>
                                        <div>
                                            <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><title>Checkmark</title><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M416 128L192 384l-96-96"/></svg>
                                        </div>
                                        <div class="item-content">
                                            <b>Fully integrated solution</b>
                                            <span>Sleekplan can be fully integrated into your web application, with only one line of code.</span>  
                                        </div>
                                    </div>
                                </div>
                                <div class="feature-item">
                                    <div>
                                        <div>
                                            <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><title>Checkmark</title><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M416 128L192 384l-96-96"/></svg>
                                        </div>
                                        <div class="item-content">
                                            <b>Track customer satisfaction</b>
                                            <span>Don't just discuss new ideas or bugs, but also keep an eye on the customer satisfaction and how it improves over time.</span>  
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="feature-more">
                        <a href="/features/" class="btn large uppercase">
                            All Features
                        </a>
                        <a href="/demo/" class="btn large uppercase">
                            Demo
                        </a>
                    </div>

                </div>
            </section>

            <section class="white alternatives">
                <div class="inner">
                    
                    <div class="content-large center">
                        <a name="alternatives"></a>
                        <h2>Top Alternatives to {{name}}</h2>
                        <span>We are convinced that you will love Sleekplan. But of course we don't want to deprive you of other great alternatives to {{name}} out there. Below you will find a list of great alternatives to {{name}}.</span>
                    </div>

                    <ul>
                        <li v-for="(alternatives, cid, index) in alternative_list" :key="cid">
                            <span>
                                <a :name="'alternative-' + alternatives.name.toLowerCase()"></a>
                                <h3>{{index + 1}}. {{alternatives.name}}</h3>
                                <span class="info"> 
                                    {{alternatives.desc}}
                                    <span>
                                        <a :href="'/alternative/' + cid + '/'" v-if="alternatives.text"><b>Alternatives</b> to {{alternatives.name}}</a>
                                        <a :href="alternatives.link" rel="nofollow noreferrer noopener" target="_blank"><b>{{alternatives.name}}</b> as {{name}} alternative</a>
                                    </span>
                                </span>
                            </span>
                        </li>
                    </ul>

                </div>
            </section>

            <section class="light" v-if="service.video">
                <div class="inner">
                    
                    <div class="content-large center">
                        <h2>{{service.video.title}}</h2>
                        <span>
                            <span v-html="service.video.text"></span>
                            <br><br>
                            <span v-html="service.video.intro"></span>
                        </span>
                    </div>

                    <div class="explainer-video">
                        <div class="video">
                            <div v-if="play === false" class="play-button" v-on:click="play = true;"></div>
                            <iframe v-if="play === true" width="560" height="315" :src="'https://www.youtube.com/embed/' + service.video.id" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        </div>
                    </div>

                </div>
            </section>

            <section class="color end">
                <div class="inner large">
                    
                    <div class="content-large center">
                        <h2>Enough Scrolling, <br>make the switch from {{name}}!</h2>
                        <span>If you're interested in making the switch, we offer a free migration from {{name}}. The Sleekplan support team is here to help you with any questions. Effortlessly capture, track and organise your customers' feedback with a system built around your needs.</span>
                        <div class="button-area">
                            <a href="https://app.sleekplan.com/sign-up/" class="btn large">Make the switch</a>
                            <span class="btn-sub">Free, no credit card required</span>
                        </div>
                    </div>
                    
                </div>
            </section>

        </div>

        <div v-else class="alternative-list">

            <section class="auto start small background-dark">
                <div class="inner">
                    <div class="title">
                        <h1> Alternatives </h1>
                    </div>
                </div>
                <div class="background">
                    <div class="rect top-left"></div>
                    <div class="rect top-right"></div>
                </div>
            </section>

            <section class="round white">
                <div class="inner">
                    
                    <div class="alternative-items">

                        <div v-for="(usecase_item, index) in Object.fromEntries(Object.entries(services).filter(([key, value]) => value.text))" v-bind:key="index">
                            <a :href="'/alternative/' + index + '/'">
                                <div class="item-box">
                                    <div class="item-content">
                                        <h2>Alternative to {{usecase_item.name}}</h2>
                                        <span>{{usecase_item.desc}}</span>
                                    </div>
                                    <div class="item-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><title>Arrow Forward</title><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="48" d="M268 112l144 144-144 144M392 256H100"/></svg>
                                    </div>
                                </div>
                            </a>
                        </div>

                    </div>

                </div>
            </section>

        </div>

    </main>
</template>

<script>
export default {


    /** ----------------------------------------------------
     * View => Base data
     ----------------------------------------------------- */
    data() {
        
        // data
		return {
            logo_white: require('@/assets/media/logo/logo-white.svg'),
            logo_default: require('@/assets/media/logo/logo.svg'),
            video: false,
            play: false,
            id: this.$route.params.id,
            service: false,
            name: false,
            services: {

                sleekplan: {
                    name: 'Sleekplan',
                    desc: 'Sleekplan is the all-in-one customer feedback tool that can easily be embedded in any web application. The widget assists you to track suggestions, ideas, and bugs from your customers, share a roadmap, and keep a changelog. The Sleekplan website widget can be used to get feedback from website visitors on a variety of different aspects such as layout, design, navigation, and usability. The widget comes with a whole bunch of options when it comes to website feedback: Public and private feedback, Feature voting board, Changelog, Public Roadmap, Website screenshots, Net Promoter Score (NPS), and Customer satisfaction (CSAT).',
                    link: 'https://bit.ly/3F4GfA9',
                },

                /**
                 * Uservoice
                 */
                uservoice: {
                    migration: true,
                    name: 'Uservoice',
                    desc: 'Uservoice is a  web based service for gathering and managing customer feedback. It records user requests, ratings, ideas and problems for a website or product. Webmasters can access the information to improve their services. UserVoice was launched in California in 2008, the service is said to have over 100,000 customers worldwide and addresses large companies that want to gather customer feedback, effectively process support requests, and increase customer satisfaction.',
                    link: 'https://bit.ly/36pR6DL',
                    title: {
                        meta: 'Best UserVoice Alternatives for Customer Feedback',
                        general: 'Best Affordable UserVoice Alternatives'
                    },
                    text: `<p>You are looking for good and affordable alternatives to UserVoice? It's difficult to find out whether or not the software you choose is right for you. As we all know, acquiring new customers is a costly and difficult matter, and many companies fail. But retaining customers in the long term can often be more difficult than winning new customers. If you want to turn <i>new customers into loyal customers</i>, you need to understand their needs perfectly and encourage an ongoing dialogue with them. In recent years, several powerful cloud tools have become established in the area of customer service and support that promise to help in this regard. These include "<b><a href="https://en.wikipedia.org/wiki/UserVoice" rel="noreferrer noopener">Uservoice</a></b>" and some alternatives. Below you find a list of alternative Enterprise Feedback Management software. Customer criticism and suggestions for improvement are of the highest importance for the makers of all products.</p><br>
                            <p>With UserVoice, <a rel="noreferrer noopener" href="https://www.microsoft.com">Microsoft</a> began some time ago to create a feedback platform where end-users and business partners can submit their suggestions and ideas for individual products. Any other user can then vote for these suggestions. So if a request is of interest to you and many others, Microsoft can see your feedback immediately. So customers can actively participate in the further development.</p>
                            <h3>UserVoice Pricing</h3>
                            <p>Until the end of 2014 Uservoice offered some different plans. Beginners were able to use the free UserVoice version, which contains only the basics. The prices for the paid plans started at $20 per user and month. Those who wanted to exploit the full potential of the solution and not do without any functions had to pay $95 per user and month for the "Ultimate" plan. Today pricing is not very transparent. The company focuses on larger customers and offers customer-based prices.</p>`,
                    meta: {
                        price: '$500/month',
                        audience: 'large companies',
                        according: 'custom',
                        easy: 'complex'
                    },
                    video: {
                        title: 'The Importance of Customer Satisfaction!',
                        text: 'The success of a company is measured on many factors: steady growth, increasing sales, and profits or the successful development of new business areas are some of these factors. <a rel="noreferrer noopener" href="https://www.salesforce.com/products/service-cloud/best-practices/how-to-improve-customer-satisfaction/">Customer satisfaction</a> is an equally important measure. Satisfied customers recommend a company to others and develop into important regular customers. However, customer feedback can do more than simply indicate satisfaction. It helps to optimize the structure and internal processes of a company and thus actively contribute to the growth and a long-term increase in customer satisfaction.',
                        intro: '"Run, hide, or say thank you: when faced with feedback, what do you do?" by Joy Mayer at TEDxCoMo',
                        id: 'b0bS4xJiEU8'
                    },
                    order: ["sleekplan", "canny-io","nolt-io","useresponse","hotjar","pendo-io","fider","userecho","aha-io","hellonext","userreport","get-satisfaction","emojicom","mopinion","upvoty"],
                },

                /**
                 * Get Satisfaction
                 */
                'get-satisfaction': {
                    name: 'Get Satisfaction',
                    desc: 'Get Satisfaction  is a similar service which allows companies to manage customer support and feedback through the web. It also helps companies build better products with customer input. Get Satisfaction has an API that allows programmers to access this service for third party integrations . This article will guide you how to use this API for creating your own plugin or application. With Get Satisfaction, companies can create online communities with little effort and easily integrate them into any website.',
                    link: 'https://bit.ly/2Xs8js4',
                    title: {
                        meta: false,
                        general: false
                    },
                    text: `<p>You are looking for good and affordable alternatives to Get Satisfaction? <a rel="noreferrer noopener" href="https://en.wikipedia.org/wiki/Get_Satisfaction">Get Satisfaction</a> enables companies to create online communities with little effort and integrate them easily into any website. The goal is to drive open and transparent communication with customers. Social networks play a decisive role in this and are seamlessly integrated into the platform. This allows companies to centrally track and control all online activities on the most important social media channels relating to their own brand. In addition, the service offers numerous tools and integration options that make it easy for customers to contribute their own ideas for new features and express their opinions, wishes and needs. It can be difficult to find out whether or not the software you choose is right for you. Below we have put together a list of Enterprise Customer Feedback Management software.</p>
                            <h3>Get Satisfaction Pricing</h3>
                            <p>The last known plans are that the subscription starts at $39 per month for annual payment and $49 per month for monthly payment with a 30-day trial version for monthly subscriptions. However, today the company only offers custom pricing.</p>`,
                    meta: {
                        price: 'custom quotes',
                        audience: 'SMES to large companies',
                        according: 'custom',
                        easy: 'medium'
                    },
                    order: ["hotjar", "sleekplan", "hellonext","aha-io","canny-io","uservoice","upvoty","emojicom","userecho","pendo-io","userreport","useresponse","mopinion","fider","nolt-io"]
                },

                hotjar: {
                    name: 'Hotjar',
                    desc: 'Hotjar offers two main tools: analysis and feedback. These include the tools Heatmaps, Conversion Funnels, Form Analytics, and Visitor Recording. With these analysis tools, companies can monitor and measure user behavior. Hotjar provides visual representations of website visitors and their usage behavior.',
                    link: 'https://bit.ly/2Txbbmq',
                },

                /**
                 * Canny.io
                 */
                'canny-io': {
                    migration: true,
                    name: 'Canny.io',
                    desc: 'Canny.io is a feature voting and changelog tool for product managers. It allows companies to get feedback from their users and get a feel of what features are in high demand for future releases. Canny.io is a b2b customer feedback solution, providing companies with an easy way of collecting feedback from their customers. They can do this by using the Canny platform, which is available via a web platform. It is cloud-based solution that helps companies small to large collect, prioritize, and track feedback with simple voting features. Canny.io lets you track which customers want which feature. This data helps your team make more robust product decisions.',
                    link: 'https://bit.ly/3gidovV',
                    title: {
                        meta: '14 Top Alternatives to Canny.io: Alternative tools and competitors',
                        general: 'The best Alternative to Canny.io'
                    },
                    text: `<p>You are looking for good alternatives and competitors to Canny.io? What's difficult is finding out whether or not the software you choose is right for you. In addition to the classic help desk tools, there are growing numbers of services on the cloud market, such as Canny.io, which combine the typical features of ticketing and support with marketing tools such as customer feedback. A Canny.io support forum for example lets you record, process, and evaluated feature requests from your customers. A voting mechanism makes it possible to see which features the users really want. The implementation and design of features can be discussed together. The goal is to drive open and transparent communication with customers. And there are some greate alternatives to Canny.io out there you can find them below.</p>
                            <h3>What is a customer feedback tool?</h3>
                            <p>Customer feedback tools are widely used by software companies. The applications offer many tools that give customers the opportunity to suggest their own ideas for new features, ask questions, report problems or bugs and seek help. If you are looking for alternatives to Canny.io, we have put together a list of customer feedback management tools below.</p>
                            <h3>Canny.io Pricing</h3>
                            <p>Canny.io is located in the mid to high price range compared to other customer feedback tools. Prices at Canny.io start at $50 per month, for this price the number of users is limited to 100. The pricing model scales with the number of users (For example, for 1000 users you pay $200).</p>`,
                    meta: {
                        price: '$50/month',
                        audience: 'all size companies',
                        according: 'tracked users',
                        easy: 'easy'
                    },
                    video: {
                        title: 'How to get Meaningful Customer Feedback?',
                        text: 'Well, you can not always satisfy everybody. And yet satisfaction is what customers expect. When you run an online business, you must do everything you can to satisfy as many customers as possible. This is exactly where <a rel="noreferrer noopener" href="https://en.wikipedia.org/wiki/Customer_feedback_management_services">Customer Feedback Management</a> (CFM) comes in. CFM does what Google and Facebook can not. While ratings there are only "good" and "bad", CFM goes deeper and illustrates what your customers really think. Many companies obtain customer feedback by using a variety of secondary survey and other feedback tools. Much softer is the question of how meaningful the feedback is and how it can help to focus the service or product.',
                        intro: '"Get in the Van" and Other Tips for Getting Meaningful Customer Feedback by Michael Sippey',
                        id: 'DXVEiARMR1E'
                    },
                    order: ["userecho","sleekplan","hotjar","uservoice","upvoty","userreport","hellonext","nolt-io","mopinion","emojicom","shipright","pendo-io","fider","aha-io","useresponse"],
                    features: [
                        {text: 'Feedback Board', sleekplan: true, other: true},
                        {text: 'Roadmap', sleekplan: true, other: true},
                        {text: 'Changelog', sleekplan: true, other: true},
                        {text: 'NPS & CSAT', sleekplan: true, other: false},
                        {text: 'Fully featured in-app widget', sleekplan: true, other: false},
                        {text: 'Custom email domain', sleekplan: true, other: false},
                        {text: 'Unlimited tracked user', sleekplan: true, other: false},
                    ]
                },

                /**
                 * Upvoty
                 */
                upvoty: {
                    migration: true,
                    name: 'Upvoty',
                    desc: 'Upvoty is a service that allows websites to integrate user voting system. Users can vote on feature requests and suggestions, giving website owners an insight into what is popular right now. Upvoty is used by SaaS companies, start-ups or basically anyone who needs user feedback and cares about product optimization can use canny to turn feedback from your users into actionable product optimizations.',
                    link: 'https://bit.ly/2M0qy2p',
                    title: {
                        meta: 'Top Alternatives to Upvoty: Best tools for Feedback and Changelog',
                        general: 'Best Alternatives for Upvoty.com'
                    },
                    text: `<p>Upvoty is a user feedback tool that provides a quick and easy-to-use solution to company's feedback needs. It is created with the goal of making it easier for companies to collect customer feedback in a votable idea board. There are many alternative tools that companies can use to gather customer feedback: Upvoty wants to privde a way to collect public customer feedback using a simple platform. They offer various features such as Feedback boards, Product roadmap, Changelog, Custom domain and some more.</p>
                            <h3>💡 So, are there any Upvoty alternatives?</h3>
                            <p>There are many reasons why people choose Sleekplan as an alternative over Upvoty. Some of the reasons are that Sleekplan has an intuitive interface that is very easy to use - for end-users and team members as well. It also has a free 30-day trial for customers to test out the product before they invest in it, - and even a free plan. It also offers more in-depth features than Upvoty, such as segmentation.</p>
                            <h3>💵 Upvoty Pricing</h3>
                            <p>The pricing plan for Upvoty starts from $15/mo for up to 150 tracked users and 1 board and goes all the way up to $49 for unlimited tracked users and boards.</p>`,
                    meta: {
                        price: '$15/month',
                        audience: 'Small to mid-size SaaS-Businesses',
                        according: 'tracked users',
                        easy: 'easy'
                    },
                    video: {
                        title: 'Customer feedback for SaaS products',
                        text: 'As a SaaS company, you want to know the customer feedback for your product. You can get this feedback by using various methods like surveys and analytics on your website. One of the most effective methods is surveying customers and gaining their feedback. It helps to separate the customer experience from the product experience. Surveys allow you to conduct research and get responses from a wider range of people in order to get better results. Surveys are one of the most effective methods for gaining customers’ feedback. Surveys allow you to conduct research and separate the customer experience from the product experience. Surveys have also been shown to increase customer loyalty, as they have a greater sense of connection to the company.',
                        intro: 'How to create the perfect customer survey?',
                        id: '_ynNHXxEYDI'
                    },
                    order: ["sleekplan","fider","userreport","get-satisfaction","nolt-io","emojicom","canny-io","shipright","hellonext","userecho","mopinion","pendo-io","uservoice","hotjar","useresponse"]
                },

                /**
                 * UserEcho
                 */
                userecho: {
                    name: 'UserEcho',
                    desc: 'UserEcho is a tool to deal with your clients, their wishes, ideas and requirements. UserEcho is feedback and request system for websites and products. It captures user feedback and requests which can be used by developers to improve their products. UserEcho allows sharing of the information with other people in an organization who might not otherwise have access to it. This makes it easier for project managers, product managers and marketers to see what customers want.',
                    link: 'https://bit.ly/3eph1hV',
                    title: {
                        meta: 'The Best UserEcho Alternatives and similar User Feedback Tools',
                        general: 'Best UserEcho Alternative and Similar Tools'
                    },
                    text: `<p>You are looking for good alternatives and competitors to UserEcho? UserEcho is well-tried but the user interface seems to be not that modern and fancy as other alternatives out there manage it today. UserEcho can score points especially with smaller companies that need a solution that is as easy and compact as possible. The software consists of three important core modules: support forum, help desk and live chat, and according to the manufacturer, the aim is to create open and transparent communication with existing and potential customers online. Social networks play a central role and can be seamlessly integrated into the company's own support portal. Another advantage of UserEcho is its numerous tools and integration possibilities. For example, a useful feedback widget is available that can be integrated into any website. This allows customers to contribute their own ideas and suggestions, and express criticism. What's difficult is finding out whether or not the software you choose is right for you. There are some alternatives to UserEcho that helps business of all sizes to keep in touch with their customers, giving them the opportunity to express themselves through forums, surveys and feedback.</p>
                            <h3>UserEcho Pricing</h3>
                            <p>UserEcho does not offer a free version. There is only one plan available from $19/month per agent (billed anually) or $25/month per agent (billed mobthly). Other packages like white-labeling are available for additional $100/month.</p>`,
                    meta: {
                        price: '$19/month (annually)',
                        audience: 'SMES to large companies',
                        according: 'agent seats',
                        easy: 'medium'
                    },
                    video: {
                        title: 'How to gather user feedback for prototypes?',
                        text: 'When you have built your prototypes based on the ideas you or your team have come up with, it is time to get feedback from the people you are going to test them on. Enhancing the way you collect feedback - and thus learn from your own prototypes and users - is essential to save time and resources in the prototype and testing phase of the Design Thinking approach - and in any other human-centric design process. If you work in a fast and efficient way, you can move quickly from prototype creation, through design and testing, to gathering feedback and finally to build a new and improved version of your prototypes or product ideas.',
                        intro: 'How to prototype and gather user feedback as quickly as possible by Steve Jarrett, CPO at DICE',
                        id: 'J8zX1ArgzDc'
                    },
                    order: ["pendo-io","sleekplan","userreport","fider","emojicom","nolt-io","shipright","get-satisfaction","hotjar","hellonext","canny-io","upvoty","mopinion","uservoice","useresponse"]
                },

                /**
                 * Nolt.io
                 */
                'nolt-io': {
                    name: 'Nolt',
                    desc: 'Nolt is a really affordable feedback solution compared with others here.  Nolt can be used on more than one website and requires no installation. It is a great solution for people who want to get customers opinions. Nolt is a platform that allows anyone to collect crowdsourcing feedback from customers, employees, friends or any other group that can give feedback.',
                    link: 'https://bit.ly/2ysEhfm',
                    title: {
                        meta: 'Best Alternative to Nolt.io - Alternatives & Competitors',
                        general: 'Top Alternatives to Nolt.io'
                    },
                    text: `<p>Nolt is an easy and quick way to gather user feedback. Nolt is a platform that allows anyone to collect feedback from customers, employees, friends or any other group that can provide the feedback they need. Nolt allows you to prioritise comments, create a roadmap with a few clicks and keep users up to date with automatic updates.</p>
                            <h3>Alternatives to Nolt?</h3>
                            <p>However, Nolt is a very standardized solution that has little room for flexibility. So you might be looking for a better alternative to Nolt? Let us first look at Nolts pricing structure.</p>
                            <h3>Nolt.io Pricing</h3>
                            <p>Like Sleekplan, Nolt is also located in the low price range compared to other customer feedback tools. There is only one plan for $25/month per board.</p>`,
                    meta: {
                        price: '$25/month',
                        audience: 'small to medium size companies',
                        according: 'flat',
                        easy: 'easy'
                    },
                    video: {
                        title: 'What is customer centricity?',
                        text: 'Companies in all industries are abandoning traditional business and product strategies as they begin to adopt the idea of customer orientation. While it is natural to be business, product or sales-oriented, brands can no longer afford to think only about what is good for the company without considering the impact on the customer. Customer centricity is often seen as a starting point for ideas such as customer satisfaction, customer experience and customer feedback, but being truly customer-centric is more than that. It is about more than making your customers happy. And it is not enough to assume that you know what your customers need.',
                        intro: 'The 3 pitfalls of customer centricity!',
                        id: '2WWPAUTYtt8'
                    },
                    order: ["sleekplan","hotjar","emojicom","mopinion","userecho","userreport","upvoty","shipright","canny-io","fider","aha-io","useresponse","uservoice","pendo-io","hellonext"]
                },

                /**
                 * Aha.io
                 */
                'aha-io': {
                    name: 'Aha!',
                    desc: 'Aha.io empowers product managers to understand the why, when and what of products by helping them to create complex product portfolios, complete with schedules, goals, release strategies and more. Aha.io is a roadmapping and product management tool for teams. It allows teams to create, prioritize and plan the features of their products. Aha has an API that programmers can use in their own applications or websites to display this information.',
                    link: 'https://bit.ly/2TyBbO6',
                    title: {
                        meta: 'Best Aha! Alternatives | Feedback with feature voting, Roadmap, and Changelog',
                        general: false
                    },
                    text: `<p>You are looking for an alternative product roadmap to Aha.io? Product roadmap software assists product managers and developers to create accurate plans and schedules for their products. With tools for team collaboration and customer feedback, <a rel="noreferrer noopener" href="https://de.wikipedia.org/wiki/Roadmap">Product Roadmap</a> software helps you develop project goals and manage the entire product life cycle. Aha.io is a product management software for your entire product life cycle. If you are looking for alternatives to Aha.io, you should first think carefully about what you and your team need. Every alternative to Aha.io has its advantages and disadvantages and not all alternatives can do everything equally well. To find the best alternative to Aha.io take a look at our checklist below.</p>
                            <h3>The five key points to consider when reviewing a roadmap tool:</h3>
                            <p>
                                <ol>
                                    <li><i>Time saving</i>. Does the roadmap tool makes it much easier for you to visually plan, create and update your project?</li>
                                    <li><i>Adjustment</i>. Every project is different. So is it a good idea to use the same colours and shapes for everyone? Certainly not.</li>
                                    <li><i>Easy-to-use</i>. Most of the work these days is collaborative and you are always in close contact with a customer or team. That's why you need a roadmap tool that works the way your customers and team do.</li>
                                    <li><i>Integrations</i>. You should choose a roadmap tool that can be easily integrated with your existing project management software.</li>
                                    <li><i>Customer Feedback</i>. You should choose a roadmap tool that allows you to integrate customer feedback within your planning.</li>
                                </ol>
                            </p>
                            <h3>Aha.io Pricing</h3>
                            <p>Aha.io offers its customers a free 30-day trial to get a first hand experience with the software before they pay for it. The Premium Plan is $59 per user/month and is billed annually. It includes all the features you need to establish a strategy, build roadmaps, create plans, set priorities, and gather feedback.</p>`,
                    meta: {
                        price: '$59/month (anually)',
                        audience: 'all size companies',
                        according: 'seats',
                        easy: 'easy'
                    },
                    video: {
                        title: 'Collect customer feedback without committing to SaaS product roadmap',
                        text: 'In short, a roadmap is a strategic planning technique in which the goals and main outcomes (tasks, milestones) of a project are summarized on a time axis in a single visual representation or graphic. You should always remember that a roadmap planner differs from a normal project plan in that it does not contain all the details of a project. Instead, it is a high-level strategic tool that is easy to understand.',
                        intro: '<b>Must watch video by Dan Martell</b>: "How To collect customer feedback without committing to SaaS product roadmap"',
                        id: 'uw0tNsDC7yI'
                    },
                    order: ["sleekplan","get-satisfaction","mopinion","useresponse","canny-io","nolt-io","uservoice","emojicom","hotjar","hellonext","userecho","shipright","userreport","fider","pendo-io"]
                },

                /**
                 * Getbeamer
                 */
                getbeamer: {
                    name: 'GetBeamer',
                    desc: 'GetBeamer.com is a software to announce your product news, bug fixes, new features, and marketing announcements to your audience.',
                    link: 'https://bit.ly/3DIVuO4',
                    title: {
                        meta: '16 Top GetBeamer (Beamer) Alternatives: Changelog with Customer Feedback',
                        general: 'Best Alternatives to GetBeamer.com (Beamer)'
                    },
                    text: `
                            <p>GetBeamer.com (or Beamer) is an alternative to the classic email newsletter. You can use their software to announce your news, bug fixing, product features, and more to your audience. For example, it can deliver all marketing messages to your audience.</p>
                            <h3>Beamer: A changelog tool to announce relevant news</h3>
                            <p>Changelog is a simple, lightweight and easy-to-use tool that helps you create an interactive changelogs for your product and software to efficiently deliver product updates. Changelog tools like GetBeamer can be used by software developer, product managers, and even marketing teams, from individuals to enterprises with hundreds of developers. A changelog tool or release note tool can not only be used to showcase changes between versions but also to announce new features, share important product updates and even marketing content.</p>
                            <h3>Alternative changelog tools to GetBeamer?</h3>
                            <p>GetBeamer is by far not the only tool to keep a changelog. There are a lot of different tools (like Sleekplan) that offer similar or even more advanced features compared to GetBeamer. First, let's take a quick look at the facts about Beamer and why Sleekplan is a good fit for you!</p>
                            <h3>GetBeamer Pricing</h3>
                            <p>GetBeamer (Beamer) has a recurring pricing model starting at <b>$0</b> up to <b>$249/month</b> if <b>billed anually</b>. The lowest plan comes with a maximum of <b>1000 monthly visitors</b> up to unlimited in the highest plan.</p> GetBeamer is a cheap alternative to other changelog tools if you only need basic features, but Beamer can quickly become expensive on advanced usage and needs.`,
                    meta: {
                        price: '$49/month (anually)',
                        audience: 'all size companies',
                        according: 'set of features & monthly visitors',
                        easy: 'easy'
                    },
                    order: ["sleekplan","nolt-io","hellonext","emojicom","aha-io","mopinion","userecho","userreport","get-satisfaction","fider","upvoty","shipright","pendo-io","hotjar","uservoice","useresponse","canny-io"]
                },

                shipright: {
                    name: 'Shipright',
                    desc: 'As companies grow, they find it difficult to listen and respond to customer feedback. Shipright captures customer needs and requests which can be used by developers to improve their products. Shipright allows sharing of this information with other people in your organization who might not otherwise have access to it. Shipright is a service that can help companies understand their customers feedback better to build products that users love.',
                    link: 'https://bit.ly/2WZhzVu',
                },
                hellonext: {
                    name: 'Hellonext',
                    desc: 'Collect and organize your customer feedback and keep your users informed about the latest updates. Hellonext is a simple web-based feedback tool for websites and apps. It captures user requests and allows viewers to vote on the importance of each request.',
                    link: 'https://bit.ly/2LWlxYI',
                },
                'pendo-io': {
                    name: 'Pendo.io',
                    desc: 'Pendo enables users to provide insight, user guidance and user communication for digital product teams. The service enables understanding product usage, gathering feedback, measuring NPS and onboard users and announcing new features within the application. Pendo.io is a user feedback and product analytics service for websites. It captures and analyze customer needs which can be used by developers to improve their products.',
                    link: 'https://bit.ly/3c0yZW2',
                },
                emojicom: {
                    name: 'Emojicom',
                    desc: 'Emojico is a really fun way to get feedback from customers. This service allows websites to show emojis as options for users to express their feelings about features on the website. Emojico has an API that programmers can use in their own applications or websites to display this information. It is a very simple but also basic service for collecting feedback using emojis.',
                    link: 'https://bit.ly/3gk5vGg',
                },
                useresponse: {
                    name: 'UseResponse',
                    desc: 'UseResponse is an integrated customer support application that combines the functions of a support ticketing center, feedback communities, live chat and knowledge database in a single package. UseResponse is a simple feedback tool for websites. It works by displaying small bars at the bottom of your site, asking visitors their opinion on various aspects of the site. It then shows them aggregate results (i.e., how many people like or dislike this feature).',
                    link: 'https://bit.ly/2ZCwG94',
                },
                userreport: {
                    name: 'UserReport',
                    desc: 'UserReport is a feedback management system with an integrated survey function, from which visitor data can be collected and ideas for possible improvements to the website can be gathered. UserReport is a feedback and request system for websites. It captures user feedback and requests which can be used by developers to improve their products.',
                    link: 'https://bit.ly/2TBldTs',
                },
                mopinion: {
                    name: 'Mopinion',
                    desc: 'Mopinion is an all-in-one user feedback platform that helps digital businesses listen, understand and act across the Internet. The Feedback tool lets you create polls for your users, ask open-ended questions, set up feedback categories and allows for A/B testing of designs or versions of pages/features etc. Mopinion gives you a lot of insight into who your visitors are so you can target them better in the future as well as improve already existing features. Their support is excellent which makes using this tool even more worthwhile!',
                    link: 'https://bit.ly/2TA5oN0',
                },
                fider: {
                    name: 'Fider',
                    desc: 'Let your customers share, vote and discuss on suggestions they have to make your product even better. Fider is an open source tool that can help you to collect feedback and prioritize so that you can focus on developing the right product.',
                    link: 'https://bit.ly/3epjEjN',
                }
            },
            redirect: {
                canny: 'canny-io'
            }
        };

    },


    /** ----------------------------------------------------
     * View => Dynamical access to data
     ----------------------------------------------------- */
    computed: {

        alternative_list() {

            // load alternatives
            let alternatives = Object.assign({}, this.services);
            // new alternatives
            let alternatives_new = {};
            // remove the current alternative
            delete alternatives[this.id];
            // load order
            let order = this.services[this.id].order;
            // create ordered array
            for( var i = 0; i < order.length - 1; i++ ) {
                // load alternatives
                alternatives_new[order[i]] = alternatives[order[i]];
            }
            // return alternatives
            return alternatives_new;

        },

    },


    /** ----------------------------------------------------
     * View => Methods
     ----------------------------------------------------- */
    methods: {

       load_alternative( id = false ) {

            // check if we have a service
            if( this.services[id] ) {
                // set data
                this.service = this.services[id];
                this.name    = this.service.name;
            // check if we have a redirect
            } else if( this.redirect[id] ) {
                // load redirect
                location.href = '/alternative/' + this.redirect[id];
                // stop
                return true;
            // else return error
            } else if( id !== false ) {   
                // load 404
                location.href = '/error';
                // stop
                return true;
            }

       },

       alternative_array() {

            let have = {10000: true};
            var j = 10000;
            let alterantives_order = [];
            // load alternatives
            //let alternatives_new = Object.assign({}, this.services);
            // load alternatives
            let alternatives = Object.assign({}, this.services);
            // remove the current alternative
            delete alternatives[this.id];
            // alternatives to Array
            let alternatives_array  = Object.keys(alternatives).map(function (key) {
                return key;
            });
            // suhuffle data
            for (var i = 0; i < alternatives_array.length - 1; i++) {
                while( have[j] === true ) {
                    j = Math.floor(Math.random() * (alternatives_array.length));
                }
                have[j] = true;
                alterantives_order[i] = alternatives_array[j];
            }
            // eslint-disable-next-line no-console
            console.log(JSON.stringify(alterantives_order));

       },

	},


    /** ----------------------------------------------------
     * View => On Mount
     ----------------------------------------------------- */
    mounted() {

        // add class
        this.$parent.$refs['home-header'].menu_transparent = true;
        this.$parent.$refs['home-header'].logo = this.logo_white;

        // load stats
        this.load_alternative( this.id );

        // load alternatives
        //this.alternative_array();

    },


    /** ----------------------------------------------------
     * View => On Destroyed
     ----------------------------------------------------- */
    destroyed() {

        // remove class
        this.$parent.$refs['home-header'].menu_transparent = false;
        this.$parent.$refs['home-header'].logo = this.logo_default;

    },


    /** ----------------------------------------------------
     * Header
     ----------------------------------------------------- */
    head: {
        // Meta title
        title: function () {
            // custom title
            let title = (
                ( this.services[this.$route.params.id].title && this.services[this.$route.params.id].title.meta !== false ) 
                ? this.services[this.$route.params.id].title.meta 
                : 'What is the best ' + this.$route.params.id.charAt(0).toUpperCase() + this.$route.params.id.slice(1) + ' alternative?'
            );
            return {
                inner: title,
                separator: '|',
                complement: 'Sleekplan'
            };
        },
        // Meta tags
        meta: [
            { 
                name: 'description', 
                content: '', 
                id: 'desc' 
            },
            { name: 'robots', content: 'index,follow' },
        ],
        // Link tags
        link: [
            { 
                rel: 'canonical', 
                href: 'https://sleekplan.com' + location.pathname,  
                id: 'canonical' 
            },
        ]
    }


}
</script>